import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import session from '@/store/session'
import cart from '@/store/cart'
import wallet from '@/store/wallet'

const store = createStore({
  modules: {
    session,
    cart,
    wallet,
  },
  plugins: [
    createPersistedState({
      paths: ['session', 'cart', 'wallet'],
      storage: window.localStorage
    })
  ]
})

export default store